import React from "react";
import PropTypes from "prop-types";
import { Empty } from "antd";

/**
 * Verification-call transcript rendered as a clean two-party conversation.
 * Agent turns align left, borrower turns align right.
 */
const CallTranscript = ({ transcript }) => {
    if (!transcript || !transcript.length) {
        return <Empty description={"Transcript not available"} />;
    }
    return (
        <ul className={"cc-transcript"}>
            {transcript.map((turn, index) => {
                const isBorrower = turn.speaker === "Borrower";
                return (
                    <li
                        key={index}
                        className={
                            "cc-transcript__turn" +
                            (isBorrower ? " cc-transcript__turn--borrower" : "")
                        }
                    >
                        <div className={"cc-transcript__bubble"}>
                            <div className={"cc-transcript__meta"}>
                                <span className={"cc-transcript__speaker"}>
                                    {turn.speaker}
                                </span>
                                {turn.time ? (
                                    <span className={"cc-transcript__time"}>
                                        {turn.time}
                                    </span>
                                ) : null}
                            </div>
                            <p className={"cc-transcript__text"}>{turn.text}</p>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

CallTranscript.propTypes = {
    transcript: PropTypes.arrayOf(
        PropTypes.shape({
            speaker: PropTypes.string,
            time: PropTypes.string,
            text: PropTypes.string
        })
    )
};

export default CallTranscript;
